define('components/factory/views/ProductView', [
	'components/factory/templates/productview',
    'components/ecrinbridge/EcrinBridge',
    'components/trackingbridge/TrackingBridge'
], function(tpl, EcrinBridge, TrackingBridge) {

	var ProductView = Mazarine.View.extend({

        events: {
            "click .js-maz-product-nuance": "onClickSwatch",
            "mouseenter .js-maz-product-nuance": "onSwatchEnter",
            "mouseleave .js-maz-product-nuance": "onSwatchLeave",
            "change .js-maz-product-capacity": "onCapacityChange",
            "change .js-maz-product-retailer": "onRetailerChange",
            "change .js-maz-product-quantity": "onInputQuantityChange",
            "change .js-maz-product-swatch-filter": "onInputFilterChange",
            "click .js-maz-addtocart": "onClickAddToCart",
            "click .maz-product-btn-action": "onClickBtnAction",
            "click .js-maz-open-swatch": "onClickOpenSwatchButton",
            "click .js-maz-close-swatch": "onClickCloseSwatchButton",
            "click .js-maz-product-btn-retailer": "onClickBtnRetailer",
            "click .maz-product-knowmore": "onClickBtnKnowmore"
        },

        template: tpl,

        className: "maz-product-view",

        initialize: function() {
            this.listenTo(this.model, 'change:codeY', this.prefetch);
            this.listenTo(this.model, 'change:datas', this.onReady);
            this.listenTo(this.model, 'change:error', this.onError);
            this.listenTo(this.model, 'change:currentSku', this.onSkuChange);
            this.listenTo(this.model, 'change:currentFilter', this.onFilterChange);
            this.listenTo(this.model, 'change:rollSku', this.onSkuChange);
            this.listenTo(this.model, 'change:quantity', this.onQuantityChange);

            this.prefetch();
        },

        /*
         * Get product datas
         */
        prefetch: function() {
            this.model.set('datas', null); //To trigger a render with the loader
            this.model.urlRoot = this.model.get('wsRoot').replace('{{codeY}}', this.model.get('codeY'));
            this.model.fetch({ timeout: 20000, cache: true, error: _.bind( this.model.onError, this.model ) });
        },

        /*
         * Call when datas change
         */
        onReady: function() {
            if (this.model.get('datas')) {

                this.model.set('currentSku', this.model.get('defaultSku') );

                this.render();
                this.createCustomSelect();

                this.onSkuChange( this.model, this.model.get('currentSku') );

                var impression = this.model.getCurrentSkuInfo().hoverTrackObject;

                if( impression && impression.ecommerce && impression.ecommerce.impressions && this.model.get('shouldTrackImpression') ) {
                    impression.ecommerce.impressions[0].list = this.model.get('currentSiteTitle');
                    impression.ecommerce.impressions[0].position = this.model.get('positionInPage');

                    // if track impression is delegated, prevent track event
                    if (this.model.get('delegateTrackImpression')) {
                        this.model.set('trackingImpression', impression.ecommerce.impressions);
                    } else {
                        TrackingBridge.trackObj(impression, "trackingimpression");
                    }
                }

                if (this.model.get('suffixClass') === "grid") {
                    this.$('.maz-product-color').clone().insertBefore(this.$('.maz-product-colorpicker'));
                }

                this.loadImages([ this.model.getCurrentSkuInfo().assets.packshot ]);

            } else {

                this.render();
                this.model.set('isReady', false);
            }
        },

        /*
         * Set model ready when packshot is loaded
         */
        progress: function( img, nbImagesPreloaded, nbImagesToPreload, finished ) {
            if( finished ) {
                this.model.set('isReady', true);
            }
        },

        /*
         * Handle error
         */
        onError: function( error ) {
            this.render();
            this.model.set('isReady', !!error);
        },

        getRenderDatas: function(){
          var obj = this.model.toJSON();
          obj.currentSku = this.model.getCurrentSkuInfo();
          if (this.model.get('overridePriceWithSubtitlePlusPrice')) {
            var datas = this.model.get('datas');
            if (obj.currentSku && obj.currentSku.productPriceWithCurrency && obj.currentSku.productPriceWithCurrency.indexOf(datas.wording.subtitle) === -1) {
              obj.currentSku.productPriceWithCurrency = datas.wording.subtitle + ' - ' + obj.currentSku.productPriceWithCurrency
            }
          }
          return obj;
        },

        createCustomSelect: function() {
            this.$('.maz-product-capacity option[value="' + this.model.get('currentSku') + '"]').attr("selected", "true");
            this.$('.maz-select-custom').mazCustomSelect({prefix: "maz", fixwidth: true, listClass: 'maz-' + this.model.get('viewId') }); //TODO peut être config différente pour les filtres
        },

        /*
         * Call when currentSku or rollSku change in the model
         * It update the name, price and packshot of the current sku
         * and if the current sku change select it and update the addToCart button
         */
        onSkuChange: function( model, _sku ) {
            var skuInfo = this.model.getCurrentSkuInfo();

            if( model.changed.currentSku ){
                this.$('.maz-product-nuance').removeClass('maz-selected');
                this.$('.maz-product-nuance[data-sku=' + _sku + ']').addClass('maz-selected');
                this.$('.js-maz-addtocart').attr('data-sku', _sku);

                if (skuInfo && skuInfo.availability && skuInfo.availability.outOfStock === true || skuInfo && skuInfo.productPriceWithCurrency === null) {
                    this.$('.maz-product').addClass('maz-product-not-available');
                } else {
                    this.$('.maz-product').removeClass('maz-product-not-available');
                }
            }

            if( skuInfo ){
                this.$('.maz-product-color').text( skuInfo.label );
                // this.$('.maz-product-price').text( skuInfo.productPriceWithCurrency ? skuInfo.productPriceWithCurrency : "" );
                this.$('.maz-product-price').text( skuInfo.productPriceWithCurrency ? 'skuInfo.productPriceWithCurrency' : "" );
                this.$('.maz-product-packshot .maz-product-packshot-image').attr("src", skuInfo.assets.packshot);
            }
        },

        onFilterChange: function() {
            //TODO si swtach sélectionné pas ds le filtre ?

            var currentFilter = this.model.get('currentFilter');
            var swatchFilters = this.model.get('swatchFilters');

            if (currentFilter) {
                this.$('.js-maz-product-nuance').addClass('maz-hidden');

                _.each( swatchFilters[currentFilter].skus, function (sku, index) {
                    this.$('.js-maz-product-nuance[data-sku="' + sku + '"]').removeClass('maz-hidden');
                }, this);
            } else {
                this.$('.js-maz-product-nuance').removeClass('maz-hidden');
            }
        },

        onQuantityChange: function( model, _quantity) {
            this.$('.js-maz-addtocart').attr('data-quantity', _quantity);
        },

        onClickSwatch: function( e ) {
            var sku = $( e.currentTarget ).data("sku");
            this.model.set('currentSku', sku);
        },

        onSwatchEnter: function( e ) {
            var sku = $( e.currentTarget ).data("sku");
            this.model.set('rollSku', sku);
        },

        onSwatchLeave: function( e ) {
            this.model.set('rollSku', null);
        },

        onCapacityChange: function( e ) {
            var sku = $( e.currentTarget ).val();
            this.model.set('currentSku', sku);
        },

        /*
         * Show/Hide the "ok" button that open the retailer link in a new tab
         */
        onRetailerChange: function(e) {
            var link = $( e.currentTarget ).val();
            if( link ) {
                this.$('.js-maz-product-btn-retailer').attr('href', link).addClass('maz-enable');
            } else {
                this.$('.js-maz-product-btn-retailer').removeAttr('href').removeClass('maz-enable');
            }
        },

        onInputQuantityChange: function( e ) {
            var quantity = $( e.currentTarget ).val();
            this.model.set('quantity', quantity);
        },

        onInputFilterChange: function( e ) {
            var currentFilter = $( e.currentTarget ).val();
            this.model.set('currentFilter', currentFilter);
        },

        /*
         * Handle the add to cart button click
         */
        onClickAddToCart: function( e ) {
            e.preventDefault();

            // To prevent the send of the trackingproductlick and the virtual detail on popin
            if( !this.model.get('isPopinProduct') ) {
                var pcto = this.model.getCurrentSkuInfo().productClickTrackObject;

                if( pcto && pcto.ecommerce && pcto.ecommerce.click && pcto.ecommerce.click.actionField ) {
                    pcto.ecommerce.click.actionField.list = this.model.get('currentSiteTitle');
                    pcto.ecommerce.click.products[0].position = this.model.get('positionInPage');
                    pcto.ecommerce.click.products[0].list = this.model.get('currentSiteTitle');
                    TrackingBridge.trackObj(pcto, "trackingproductclicktrackobj");

                    var virtualDetail = pcto.ecommerce.click.products[0];

                    var vdo = {
                        event: 'virtualDetail',
                        ecommerce: {
                            detail: {
                                products: [{
                                    id: virtualDetail.id,
                                    category: virtualDetail.category,
                                    price: virtualDetail.price,
                                    name: virtualDetail.name,
                                    brand: virtualDetail.brand,
                                    variant: virtualDetail.variant,
                                    list: virtualDetail.list,
                                    position: virtualDetail.position
                                }]
                            }
                        }
                    };

                    TrackingBridge.trackObj(vdo, "trackingvirtualdetailsobj");
                }
            }

            if( this.model.get('suffixClass') === "basic-simple" || this.model.get('suffixClass') === "basic-multi" ){
                TrackingBridge.trackEvent('addtocartvideo', {"{{codey}}": this.model.get('codeY'), "{{skucode}}": this.model.get('currentSku')});
                if( this.model.getCurrentSkuInfo().clickTrackObject ) {
                    TrackingBridge.trackObj(this.model.getCurrentSkuInfo().clickTrackObject, "trackingclicktrackobj");
                }
            } else {
                TrackingBridge.trackEvent('addtocart', { "{{codey}}": this.model.get('codeY'), "{{skucode}}": this.model.get('currentSku') } );
                if( this.model.getCurrentSkuInfo().clickTrackObject ) {
                    TrackingBridge.trackObj(this.model.getCurrentSkuInfo().clickTrackObject, "trackingclicktrackobj");
                }
            }

            // EcrinBridge.addItemToCart(e, this.model.get('onAddToCartCallback'));
            if ( this.model.get('isEcrinHorizon') ) {
                this.openProductPageOnDiorSite();
            }

        },

        openProductPageOnDiorSite: function() {
          var codeY = this.model.get('codeY');
          var currentSku = this.model.get('currentSku');
          var datas = this.model.get('datas');
          var productHref = (datas.product && datas.product.href) ? datas.product.href : '';

          if (!codeY) {
            console.warn('codeY not defined for this product');
            return;
          }
          if (!currentSku) {
            console.warn('currentSku not defined for this product');
            return;
          }
          if (!productHref) {
            console.warn('something wrong going on with get-quick-buy-product.json service provider');
            return;
          }

          var lowerCaseCodeY = codeY.toLowerCase();
          var lowerCaseCurrentSku = currentSku.toLowerCase();

          if (productHref.indexOf(lowerCaseCodeY) === -1) {
            console.warn('codeY set in contribution do not match url given back by get-quick-buy-product.json service provider : ', codeY, productHref);
            return;
          }

          var completeProductInfo = lowerCaseCodeY + '_' + lowerCaseCurrentSku;
          var completeProductHref = productHref.replace(lowerCaseCodeY, completeProductInfo);

          window.open(completeProductHref);
        },

        onClickBtnAction: function( e ) {
            var pcto = this.model.getCurrentSkuInfo().productClickTrackObject;

            if( pcto && pcto.ecommerce && pcto.ecommerce.click && pcto.ecommerce.click.actionField ) {
                pcto.ecommerce.click.actionField.list = this.model.get('currentSiteTitle');
                pcto.ecommerce.click.products[0].position = this.model.get('positionInPage');
                pcto.ecommerce.click.products[0].list = this.model.get('currentSiteTitle');
                TrackingBridge.trackObj(pcto, "trackingproductclicktrackobj");

                var virtualDetail = pcto.ecommerce.click.products[0];

                var vdo = {
                    event: 'virtualDetail',
                    ecommerce: {
                        detail: {
                            products: [{
                                id: virtualDetail.id,
                                category: virtualDetail.category,
                                price: virtualDetail.price,
                                name: virtualDetail.name,
                                brand: virtualDetail.brand,
                                variant: virtualDetail.variant,
                                list: virtualDetail.list,
                                position: virtualDetail.position
                            }]
                        }
                    }
                };

                TrackingBridge.trackObj(vdo, "trackingvirtualdetailsobj");
            }
        },

        onClickOpenSwatchButton: function( e ) {
            e.preventDefault();
            this.openPopinSwatch();
        },

        onClickCloseSwatchButton: function( e ) {
            e.preventDefault();
            this.closePopinSwatch(true);
        },

        openPopinSwatch: function() {
            this.model.set('swatchOpened', true);
            this.$('.maz-product-colorpicker').addClass('visible');
        },

        closePopinSwatch: function( isManual ) {
            this.model.set('swatchOpened', false, {silent: !isManual});
            this.$('.maz-product-colorpicker').removeClass('visible');
        },

        onClickBtnRetailer: function( e ) {
            if( $(e.currentTarget).attr('href') && $(e.currentTarget).attr('href') !== "" ) {
                TrackingBridge.trackEvent('trackingretailer', {
                    "{{retailername}}": _.findWhere(this.model.get('retailers'), {link: $(e.currentTarget).attr('href') }).label,
                    "{{retailerurl}}": this.$('.js-maz-product-btn-retailer').attr("href")
                });
            } else {
                e.preventDefault();
                return false;
            }
        },

        onClickBtnKnowmore: function( e ) {
            TrackingBridge.trackEvent('trackingknowmore', { "{{productname}}": this.model.get('datas').wording.title, "{{codey}}": this.model.get('codeY') });

            var pcto = this.model.getCurrentSkuInfo().productClickTrackObject;

            if( pcto && pcto.ecommerce && pcto.ecommerce.click && !this.model.get('isPopinProduct') ) {
                pcto.ecommerce.click.actionField.list = this.model.get('currentSiteTitle');
                TrackingBridge.trackObj(pcto, "trackingproductclicktrackobj");
            }
        }
	});

	return ProductView;
});
